export default __webpack_public_path__ + "static/media/GameUpdates.8ddd4ad5.png";